import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../utils/PropTypesDefinitions'
import { AbsoluteComponentProps } from '../LayoutTypes'
import { BackgroundColorTypes } from '../../Theme/Fonts/FontTypes'

type AbsoluteLayoutProps = {
    component?: ReactElement
    children: ReactElement
    absoluteComponentStyle?: AbsoluteComponentProps
    backgroundColor?: BackgroundColorTypes
    expand?: boolean
} & TestID

const AbsoluteLayout: FunctionComponent<AbsoluteLayoutProps> = ({
    component,
    children,
    absoluteComponentStyle,
    expand = false,
    testID,
    backgroundColor,
}): ReactElement => {
    return (
        <Grid
            position="relative"
            noExpand={!expand}
            backgroundColor={backgroundColor}
            testID={testID}
        >
            {component}
            <Grid
                noExpand
                width="100%"
                position="absolute"
                pointerEvents="box-none"
                {...absoluteComponentStyle}
            >
                {children}
            </Grid>
        </Grid>
    )
}

export default memo(AbsoluteLayout)
